// components/ui/menu-categories.jsx
import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";

const MenuCategories = ({ selectedMainCategory, onMainCategorySelect }) => {
  console.log("--- MenuCategories ---");
  return (
    <div className="grid grid-cols-2 gap-4 px-4 py-4 max-w-xl mx-auto w-full">
      <div
        onClick={() => onMainCategorySelect("comidas")}
        className="cursor-pointer"
      >
        <Card
          className={`p-4 hover:shadow-lg transition-all ${
            selectedMainCategory === "comidas"
              ? "bg-orange-500 text-white"
              : "hover:bg-gray-50"
          }`}
        >
          <div className="flex flex-col items-center gap-3">
            <div
              className={
                selectedMainCategory === "comidas"
                  ? "text-white"
                  : "text-orange-500"
              }
            >
              <svg
                className="h-12 w-12"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2z" />
              </svg>
            </div>
            <span className="text-lg font-bold">COMIDAS</span>
          </div>
        </Card>
      </div>

      <div
        onClick={() => onMainCategorySelect("bebidas")}
        className="cursor-pointer"
      >
        <Card
          className={`p-4 hover:shadow-lg transition-all ${
            selectedMainCategory === "bebidas"
              ? "bg-orange-500 text-white"
              : "hover:bg-gray-50"
          }`}
        >
          <div className="flex flex-col items-center gap-3">
            <div
              className={
                selectedMainCategory === "bebidas"
                  ? "text-white"
                  : "text-orange-500"
              }
            >
              <svg
                className="h-12 w-12"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M3 2l2 18.23h14L21 2H3zm7 2h4v6h-4V4z" />
              </svg>
            </div>
            <span className="text-lg font-bold">BEBIDAS</span>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default MenuCategories;
